import { createSelector } from 'reselect';

import { RootState, UsageAnalyticsState } from './types';

export const usageAnalyticsSelector = (state: RootState): UsageAnalyticsState => (
  state.apps.analytics.usageAnalytics
);
export const filterBarSelector = (state: RootState) => state.apps.analytics.filterBar;

export const filterParamSelector = createSelector([
  filterBarSelector,
  usageAnalyticsSelector,
], (filterBar, usageAnalytics) => ({
  ...filterBar.requestParams,
  granularity: usageAnalytics.granularity,
}));
